import type { Metadata } from "next";
import AdminInfluencerComponent from "@/Component/Admin/AdminInfluencersListing";

export const metadata: Metadata = {
  title: "Influencer | Connector Club",
  description: "",
};

const AdminInfluencerListPage = () => {
  return (
    <AdminInfluencerComponent />
  )
}

export default AdminInfluencerListPage
